import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { EditRestaurantContext, IEditRestaurantContext } from '../../editRestaurantState/editRestaurantContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import { allRoles } from 'appConstants';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './EditRestaurantControlPanel.module.scss';

export const EditRestaurantControlPanel: React.FC = () => {
	const { featureFlags } = useContext<IAppContext>(AppContext);
	const { changeVisibleForm, visibleForm } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const hasMainFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasMainFormForClintManagerAccess = useRoleAccess([UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER]);
	const hasLocalizationFormAccess = useRoleAccess(allRoles);
	const hasStyleFormAccess = useRoleAccess(allRoles);
	const hasDeviceFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasWatchesFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasReportsFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasBankSettingsFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasAndroidWatchesFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasNfcCardsFormAccess = useRoleAccess([UserRoles.SUPER_USER]) && featureFlags.HAS_NFC_CARDS;

	return (
		<div className={style.container} data-test="EditRestaurantControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
				disabled={!hasMainFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainFormForClientManager')}
				isActive={visibleForm === 'mainFormForClientManager'}
				btnName="mainInfoBookmark"
				disabled={!hasMainFormForClintManagerAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('localizationForm')}
				isActive={visibleForm === 'localizationForm'}
				btnName="localizationBookmark"
				disabled={!hasLocalizationFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('styleForm')}
				isActive={visibleForm === 'styleForm'}
				btnName="styleBookmark"
				disabled={!hasStyleFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('devicesForm')}
				isActive={visibleForm === 'devicesForm'}
				btnName="devicesBookmark"
				disabled={!hasDeviceFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('watchesForm')}
				isActive={visibleForm === 'watchesForm'}
				btnName="watchesBookmark"
				disabled={!hasWatchesFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('reportsForm')}
				isActive={visibleForm === 'reportsForm'}
				btnName="reportSettingsBookmark"
				disabled={!hasReportsFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('bankSettingsForm')}
				isActive={visibleForm === 'bankSettingsForm'}
				btnName="bankSettingsBookmark"
				disabled={!hasBankSettingsFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('androidWatchesForm')}
				isActive={visibleForm === 'androidWatchesForm'}
				btnName="androidWatchesBookmark"
				disabled={!hasAndroidWatchesFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('nfcCardsForm')}
				isActive={visibleForm === 'nfcCardsForm'}
				btnName="nfcCardsBookmark"
				disabled={!hasNfcCardsFormAccess}
			/>
		</div>
	);
};
